//red before: #E64848
//colors for the different classes
export const colors = ["#f27052", "#89CFFD", "#FFE9AE", "#CFE8A9", "gray"]; //LIMITATION: ALLOW MAXIMUM OF 4 DIFFERENT CLASSES

export type IDataPoint = number[];

export interface IDataClass {
  className: string; //name of the class
  points: IDataPoint[]; //the array of points that belong to this class
}

export interface IData {
  data: IDataClass[]; //the data
  attrib: string[]; //Names of the attributes
  selected_attrib: [number, number] | number; //if selected_attrib is an arrray of two numbers the MyPlot component will display two dimensional points with two axes, if it is one number it will display only one axis. The numbers select the attributes accordingly to their indices in the currentData.attribs array
  selected_class: [number, number]; //The numbers select the classes accordingly to their indices in the currentData.data array
}

export const ki67positiveZellen: IData = {
  data: [
    {
      className: "Prognose eher negativ",
      points: [[3], [5], [0], [8], [6], [2], [7]],
    },
    {
      className: "Prognose eher positiv",
      points: [[30], [55], [67], [50], [90], [87], [71], [66]],
    },
  ],
  attrib: ["Anteil Ki-67 positiver Zellen"],
  selected_attrib: 0,
  selected_class: [0, 1],
};
export const schierlingDataset: IData = {
  data: [
    {
      className: "Gefleckter Schierling",
      points: [
        [127.2, 3.04],
        [113.48, 2.93],
        [129.69, 2.94],
        [136.04, 3.12],
        [116.59, 3.4],
        [121.46, 2.96],
        [127.19, 3.02],
        [111.95, 2.99],
        [132.86, 2.88],
        [149.0, 3.22],
        [135.2, 2.81],
        [125.67, 2.93],
        [156.45, 2.92],
        [124.27, 3.05],
        [108.67, 2.82],
        [122.65, 3.1],
        [157.59, 3.09],
        [88.68, 2.78],
        [158.6, 2.88],
        [94.3, 2.96],
      ],
    },
    {
      className: "Hundspetersilie",
      points: [
        [41.85, 3.86],
        [76.72, 3.92],
        [47.04, 3.69],
        [66.98, 3.7],
        [49.34, 3.78],
        [78.55, 3.79],
        [24.86, 3.76],
        [25.04, 3.86],
        [96.79, 3.82],
        [70.9, 3.73],
        [51.85, 3.72],
        [73.0, 3.95],
        [71.7, 3.8],
        [42.78, 3.63],
        [52.8, 3.68],
        [69.18, 3.92],
        [70.09, 3.78],
        [54.41, 3.8],
        [52.93, 3.78],
        [51.91, 3.75],
      ],
    },
    {
      className: "Wiesen-Kerbel",
      points: [
        [115.65, 8.41],
        [118.42, 7.37],
        [120.77, 9.56],
        [107.75, 9.89],
        [147.75, 8.09],
        [104.56, 8.28],
        [116.16, 8.54],
        [153.28, 8.75],
        [115.72, 8.35],
        [107.08, 7.84],
        [126.14, 8.48],
        [138.38, 7.9],
        [131.2, 7.64],
        [127.25, 8.0],
        [113.03, 7.32],
        [113.0, 7.63],
        [125.12, 8.86],
        [128.29, 8.17],
        [101.12, 7.68],
        [148.01, 8.52],
      ],
    },
  ],
  attrib: ["Höhe", "Früchte"],
  selected_attrib: [0, 1],
  selected_class: [0, 1],
};
export const gegenstaendeDataset: IData = {
  data: [
    {
      className: "Schwimmt im Wasser",
      points: [
        [588.3, 10],
        [294.1, 5],
        [133.3, 20],
        [217.4, 100],
        [54.3, 25],
        [55.6, 40],
        [34.7, 25],
        [333.3, 300],
        [111.1, 100],
      ],
    },
    {
      className: "Sinkt im Wasser",
      points: [
        [200, 300],
        [41.4, 87],
        [160, 400],
        [100, 250],
        [10.9, 85],
        [51.3, 400],
        [6.4, 50],
        [25.4, 200],
        [10.8, 90],
        [5.8, 60],
        [8.8, 100],
        [44.2, 500],
      ],
    },
  ],
  attrib: ["Volumen (cm^3)", "Masse (g)"],
  selected_attrib: [0, 1],
  selected_class: [0, 1],
};
export const irisDataset: IData = {
  data: [
    {
      className: "L. barnumiae",
      points: [
        [10.0, 6.0, 7.0],
        [11.5, 6.0, 7.2],
        [12.0, 6.1, 7.4],
        [13.5, 6.3, 8.0],
        [13.0, 6.5, 7.6],
        [12.0, 6.2, 7.8],
        [13.0, 6.3, 7.0],
        [10.0, 6.1, 7.5],
        [11.0, 6.0, 7.3],
        [11.0, 6.5, 7.1],
        [14.0, 6.3, 8.0],
        [13.5, 6.4, 7.9],
        [14.0, 6.4, 7.3],
        [12.5, 6.2, 7.2],
        [10.0, 6.2, 7.9],
      ],
    },
    {
      className: "L. gatasii",
      points: [
        [50.0, 10.3, 8.2],
        [35.0, 11.0, 8.4],
        [40.0, 11.4, 9.0],
        [42.0, 11.8, 9.2],
        [55.0, 10.5, 9.4],
        [60.0, 12.0, 10.2],
        [37.0, 12.2, 10.0],
        [39.0, 12.5, 11.0],
        [44.0, 12.1, 10.5],
        [57.0, 11.2, 10.1],
        [49.0, 10.1, 9.6],
        [36.0, 12.5, 9.3],
        [43.0, 10.0, 9.0],
        [55.0, 10.4, 8.5],
        [58.0, 12.3, 8.0],
      ],
    },
    {
      className: "L. grant-duffii",
      points: [
        [15.0, 17.5, 7.8],
        [28.0, 18.0, 7.9],
        [30.0, 14.0, 8.0],
        [24.0, 13.0, 8.1],
        [22.0, 11.0, 8.2],
        [30.0, 16.0, 7.8],
        [35.0, 17.0, 7.9],
        [18.0, 15.0, 7.9],
        [19.0, 11.0, 8.0],
        [21.0, 12.0, 8.1],
        [20.0, 10.0, 8.1],
        [32.0, 15.5, 8.2],
        [34.0, 13.0, 7.8],
        [28.0, 13.5, 8.0],
        [27.0, 14.0, 8.0],
      ],
    },
  ],
  attrib: ["Stängel", "Spatha", "Blütenblätter"],
  selected_attrib: [0, 1],
  selected_class: [0, 1],
};
//dummy dataset for game with 2 classes, 3 dimensions
export const dummy2C3D: IData = {
  data: [
    {
      className: "Klasse 1",
      points: [],
    },
    {
      className: "Klasse 2",
      points: [],
    },
  ],
  attrib: ["Attribut 1", "Attribut 2", "Attribut 3"],
  selected_attrib: [0, 1],
  selected_class: [0, 1],
};
//dummy dataset for game with 2 classes, 3 dimensions but just one selected attribute
export const dummy2C3D1A: IData = {
  data: [
    {
      className: "Klasse 1",
      points: [],
    },
    {
      className: "Klasse 2",
      points: [],
    },
  ],
  attrib: ["Attribut 1", "Attribut 2", "Attribut 3"],
  selected_attrib: 0,
  selected_class: [0, 1],
};
//dummy dataset for game with 2 classes, 2 dimensions
export const dummy2C2D: IData = {
  data: [
    {
      className: "Klasse 1",
      points: [],
    },
    {
      className: "Klasse 2",
      points: [],
    },
  ],
  attrib: ["Attribut 1", "Attribut 2"],
  selected_attrib: [0, 1],
  selected_class: [0, 1],
};
//dummy dataset for game with 2 classes, 2 dimensions but just one selected attribute
export const dummy2C2D1A: IData = {
  data: [
    {
      className: "Klasse 1",
      points: [],
    },
    {
      className: "Klasse 2",
      points: [],
    },
  ],
  attrib: ["Attribut 1", "Attribut 2"],
  selected_attrib: 0,
  selected_class: [0, 1],
};
export const weinsortenDataset: IData = {
  data: [
    {
      className: "Sorte 1",
      points: [
        [2.43, 2.8, 5.64],
        [2.14, 2.65, 4.38],
        [2.67, 2.8, 5.68],
        [2.5, 3.85, 7.8],
        [2.87, 2.8, 4.32],
        [2.45, 3.27, 6.75],
        [2.45, 2.5, 5.25],
        [2.61, 2.6, 5.05],
        [2.17, 2.8, 5.2],
        [2.27, 2.98, 7.22],
        [2.3, 2.95, 5.75],
        [2.41, 2.6, 5.6],
        [2.39, 3.1, 5.4],
        [2.38, 3.3, 7.5],
        [2.7, 2.85, 7.3],
        [2.72, 2.8, 6.2],
        [2.62, 2.95, 6.6],
        [2.48, 3.3, 8.7],
        [2.56, 2.7, 5.1],
        [2.28, 3.0, 5.65],
        [2.65, 2.41, 4.5],
        [2.36, 2.61, 3.8],
        [2.52, 2.48, 3.93],
        [2.61, 2.53, 3.52],
        [3.22, 2.63, 3.58],
        [2.62, 2.85, 4.8],
        [2.14, 2.4, 3.95],
        [2.8, 2.95, 4.5],
        [2.21, 2.65, 4.7],
        [2.7, 3.0, 5.7],
        [2.36, 2.86, 6.9],
        [2.36, 2.42, 3.84],
        [2.7, 2.95, 5.4],
        [2.65, 2.35, 4.2],
        [2.41, 2.7, 5.1],
        [2.84, 2.6, 4.6],
        [2.55, 2.45, 4.25],
        [2.1, 2.4, 3.7],
        [2.51, 3.0, 5.1],
        [2.31, 3.15, 6.13],
        [2.12, 2.45, 4.28],
        [2.59, 3.25, 5.43],
        [2.29, 2.64, 4.36],
        [2.1, 3.0, 5.04],
        [2.44, 2.85, 5.24],
        [2.28, 3.25, 4.9],
        [2.12, 3.1, 6.1],
        [2.4, 2.75, 6.2],
        [2.27, 2.88, 8.9],
        [2.04, 2.72, 7.2],
        [2.6, 2.45, 5.6],
        [2.42, 3.88, 7.05],
        [2.68, 3.0, 6.3],
        [2.25, 2.6, 5.85],
        [2.46, 2.96, 6.25],
        [2.3, 3.2, 6.38],
        [2.68, 3.0, 6.0],
        [2.5, 3.4, 6.8],
      ],
    },
    {
      className: "Sorte 2",
      points: [
        [2.32, 1.51, 4.1],
        [2.4, 1.3, 5.4],
        [2.4, 1.15, 5.7],
        [2.36, 1.7, 5.0],
        [2.25, 2.0, 5.45],
        [2.2, 1.62, 7.1],
        [2.54, 1.38, 3.85],
        [2.64, 1.79, 5.0],
        [2.19, 1.62, 5.7],
        [2.7, 1.54, 4.6],
        [2.35, 1.4, 5.6],
        [2.72, 1.55, 4.35],
        [2.35, 2.0, 4.4],
        [2.2, 1.38, 8.21],
        [2.15, 1.5, 4.0],
        [2.23, 0.98, 4.9],
        [2.48, 1.7, 7.65],
        [2.38, 1.93, 8.42],
        [2.36, 1.41, 9.4],
        [2.62, 1.4, 8.6],
        [2.48, 1.48, 10.8],
        [2.75, 2.2, 7.1],
        [2.28, 1.8, 10.52],
        [2.1, 1.48, 7.6],
        [2.32, 1.74, 7.9],
        [2.38, 1.8, 9.01],
        [2.64, 1.9, 7.5],
        [2.7, 2.8, 13.0],
        [2.64, 2.6, 11.75],
        [2.38, 2.3, 7.65],
        [2.54, 1.83, 5.88],
        [2.58, 1.65, 5.58],
        [2.35, 1.39, 5.28],
        [2.3, 1.35, 9.58],
        [2.26, 1.28, 6.62],
        [2.6, 1.7, 10.68],
        [2.3, 1.48, 10.26],
        [2.69, 1.55, 8.66],
        [2.86, 1.98, 8.5],
        [2.32, 1.25, 5.5],
        [2.28, 1.39, 9.9],
        [2.48, 1.68, 9.7],
        [2.45, 1.68, 7.7],
        [2.48, 1.8, 7.3],
        [2.26, 1.59, 10.2],
        [2.37, 1.65, 9.3],
        [2.74, 2.05, 9.2],
      ],
    },
  ],
  attrib: ["Ascheanteil", "Phenolgehalt", "Farbintensität"],
  selected_attrib: [0, 1],
  selected_class: [0, 1],
};
export const weizen2Dataset: IData = {
  data: [
    {
      className: "Sorte 1",
      points: [
        [6.191, 3.561, 17.63],
        [5.998, 3.484, 16.84],
        [5.978, 3.594, 17.26],
        [6.154, 3.93, 19.11],
        [6.017, 3.486, 16.82],
        [5.927, 3.438, 16.77],
        [6.064, 3.403, 17.32],
        [6.579, 3.814, 20.71],
        [6.445, 3.639, 18.94],
        [5.85, 3.566, 17.12],
        [5.875, 3.467, 16.53],
        [6.006, 3.857, 18.72],
        [6.285, 3.864, 20.2],
        [6.384, 3.772, 19.57],
        [6.366, 3.801, 19.51],
        [6.173, 3.651, 18.27],
        [6.084, 3.764, 18.88],
        [6.549, 3.67, 18.98],
        [6.573, 4.033, 21.18],
        [6.45, 4.032, 20.88],
        [6.581, 3.785, 20.1],
        [6.172, 3.796, 18.76],
        [6.272, 3.693, 18.81],
        [6.037, 3.86, 18.59],
        [6.666, 3.485, 18.36],
        [6.139, 3.463, 16.87],
        [6.341, 3.81, 19.31],
        [6.449, 3.552, 18.98],
        [6.271, 3.512, 18.17],
        [6.219, 3.684, 18.72],
        [5.718, 3.525, 16.41],
        [5.89, 3.694, 17.99],
        [6.113, 3.892, 19.46],
        [6.369, 3.681, 19.18],
        [6.248, 3.755, 18.95],
        [6.037, 3.786, 18.83],
        [6.152, 3.806, 18.85],
        [6.033, 3.573, 17.63],
        [6.675, 3.763, 19.94],
        [6.153, 3.674, 18.55],
        [6.107, 3.769, 18.45],
        [6.303, 3.791, 19.38],
        [6.183, 3.902, 19.13],
        [6.259, 3.737, 19.14],
        [6.563, 3.991, 20.97],
        [6.416, 3.719, 19.06],
        [6.051, 3.897, 18.96],
        [6.245, 3.815, 19.15],
        [6.227, 3.769, 18.89],
        [6.493, 3.857, 20.03],
        [6.315, 3.962, 20.24],
        [6.059, 3.563, 18.14],
        [5.762, 3.387, 16.17],
        [5.98, 3.771, 18.43],
        [5.363, 3.582, 15.99],
        [6.111, 3.869, 18.75],
        [6.285, 3.594, 18.65],
        [5.979, 3.687, 17.98],
        [6.513, 3.773, 20.16],
        [5.791, 3.69, 17.55],
        [5.979, 3.755, 18.3],
        [6.144, 3.825, 18.94],
        [5.884, 3.268, 15.38],
        [5.845, 3.395, 16.16],
        [5.776, 3.408, 15.56],
        [5.477, 3.465, 15.38],
        [6.145, 3.574, 17.36],
        [5.92, 3.231, 15.57],
        [5.832, 3.286, 15.6],
        [5.872, 3.472, 16.23],
      ],
    },
    {
      className: "Sorte 2",
      points: [
        [5.472, 2.994, 13.07],
        [5.541, 3.073, 13.32],
        [5.389, 3.074, 13.34],
        [5.224, 2.967, 12.22],
        [5.314, 2.777, 11.82],
        [5.279, 2.687, 11.21],
        [5.176, 2.719, 11.43],
        [5.267, 2.967, 12.49],
        [5.386, 2.911, 12.7],
        [5.317, 2.648, 10.79],
        [5.263, 2.84, 11.83],
        [5.405, 2.776, 12.01],
        [5.408, 2.833, 12.26],
        [5.22, 2.693, 11.18],
        [5.175, 2.755, 11.36],
        [5.25, 2.675, 11.19],
        [5.053, 2.849, 11.34],
        [5.394, 2.745, 12.13],
        [5.444, 2.678, 11.75],
        [5.304, 2.695, 11.49],
        [5.451, 2.879, 12.54],
        [5.35, 2.81, 12.02],
        [5.267, 2.847, 12.05],
        [5.333, 2.968, 12.55],
        [5.011, 2.794, 11.14],
        [5.105, 2.941, 12.1],
        [5.319, 2.897, 12.44],
        [5.417, 2.837, 12.15],
        [5.176, 2.668, 11.35],
        [5.09, 2.715, 11.24],
        [5.325, 2.701, 11.02],
        [5.167, 2.845, 11.55],
        [5.088, 2.763, 11.27],
        [5.136, 2.763, 11.4],
        [5.278, 2.641, 10.83],
        [4.981, 2.821, 10.8],
        [5.186, 2.71, 11.26],
        [5.145, 2.642, 10.74],
        [5.18, 2.758, 11.48],
        [5.357, 2.893, 12.21],
        [5.09, 2.775, 11.41],
        [5.236, 3.017, 12.46],
        [5.24, 2.909, 12.19],
        [5.108, 2.85, 11.65],
        [5.495, 3.026, 12.89],
        [5.363, 2.683, 11.56],
        [5.413, 2.716, 11.81],
        [5.088, 2.675, 10.91],
        [5.089, 2.821, 11.23],
        [4.899, 2.787, 10.59],
        [5.046, 2.717, 10.93],
        [5.091, 2.804, 11.27],
        [5.132, 2.953, 11.87],
        [5.18, 2.63, 10.82],
        [5.236, 2.975, 12.11],
        [5.16, 3.126, 12.8],
        [5.224, 3.054, 12.79],
        [5.32, 3.128, 13.37],
        [5.41, 2.911, 12.62],
        [5.073, 3.155, 12.76],
        [5.219, 2.989, 12.38],
        [4.984, 3.135, 12.67],
        [5.009, 2.81, 11.18],
        [5.183, 3.091, 12.7],
        [5.204, 2.96, 12.37],
        [5.137, 2.981, 12.19],
        [5.14, 2.795, 11.23],
        [5.236, 3.232, 13.2],
        [5.175, 2.836, 11.84],
        [5.243, 2.974, 12.3],
      ],
    },
  ],
  attrib: ["Länge", "Breite", "Fläche"],
  selected_attrib: [0,1],
  selected_class: [0, 1],
};
